import { css, SerializedStyles } from '@emotion/react';
import { useTheme } from '@mui/material';

export const useSummaryStatisticStyles = (): SerializedStyles => {
  const theme = useTheme();

  return css`
    padding: ${theme.spacing(3)};
    position: relative;

    .align-right {
      text-align: right;
    }

    .loader {
      position: absolute;
    }

    ${theme.breakpoints.down('sm')} {
      .stat-cell {
        display: flex;
      }
    }
  `;
};
